module.exports = __webpack_public_path__ + "img/candado1.fdd3deba.png";